<div class="row">
  <div class="col-md-4 mt-10" *ngFor="let faqCard of faqCards">
    <a href="{{ faqCard.url }}">
      <div class="card liftfaq">
        <div class="inner-container">
          <div class="card-image-header show-image" style="background-image: url('{{ faqCard?.headImage }}');">&nbsp;</div>
        </div>

        <div class="card-body">
          <h5 class="card-title" style="text-align: center">
            <i class="{{ faqCard?.headIconClass }}"></i>
            <br />
            {{ faqCard.title }}
          </h5>

          <p class="card-text blx">{{ faqCard?.body }}</p>
        </div>
      </div>
    </a>
  </div>
</div>
